import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '@shared/services/data/data.service';
import { ToastService } from '@shared/services/toast/toast.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-consent-callback-component',
  standalone: true,
  imports: [ProgressSpinnerModule],
  templateUrl: './consent-callback-component.component.html',
  styleUrl: './consent-callback-component.component.scss',
})
export class ConsentCallbackComponent implements OnInit {
  constructor(
    private router: Router,
    private toastService: ToastService,
    readonly dataService: DataService,
  ) {}

  ngOnInit(): void {
    // Check if this window was opened by another window
    if (window.opener) {
      // This means that this window has been opened by some other
      // window and we need to access the parent.
      const openerWindow = window.opener;

      // Call the relevant method on the parent window.
      try {
        openerWindow.postMessage(
          {
            type: 'consent-completed',
          },
          window.location.origin,
        );
      } catch (err) {
        this.toastService.showErrorMessage(
          this.dataService.getTexts().UnableToGetConsentInformation ?? 'Unable to get Consent Information!',
        );
      }
      window.self.close(); // this works, since the current window is being opened by a script and not the user.
    } else {
      // Handle cases where the user navigates directly to this URL.
      console.log('Opened in a new window directly');

      // just redirect, nothing to see here anyways
      this.router.navigate(['/']);
    }
  }
}
